module.exports = __webpack_public_path__ + "img/mp-1.4c34a3ad.svg";